module.exports = __webpack_public_path__ + "static/media/pasoapaso.0a9572d1.webp";